import { action, createAsyncAction } from 'typesafe-actions';
import { CustomGroupPaginatedResponse, GetCustomGroupListRequestInterface, SortDirection } from './type.d';
import * as types from './customGroupList.actionTypes';

export const setIsSuccess = (value: boolean) => action(types.SET_CUSTOM_GROUP_SUCCESS, { value });

export const setCustomGroupListPageIndex = (page: number) => action(types.SET_CUSTOM_GROUP_LIST_PAGE_INDEX, { page });

export const setCustomGroupListSearchQuery = (search: string) =>
	action(types.SET_CUSTOM_GROUP_LIST_SEARCH_QUERY, { search });

export const setCustomGroupListSort = (sortBy: string, sortDirection: SortDirection) =>
	action(types.SET_CUSTOM_GROUP_LIST_SORT, { sortBy, sortDirection });

export const resetCustomGroupListFilter = () => action(types.RESET_CUSTOM_GROUP_LIST_FILTER, {});

export const getCustomGroupList = createAsyncAction(
	types.GET_CUSTOM_GROUP_LIST_REQUEST,
	types.GET_CUSTOM_GROUP_LIST_SUCCESS,
	types.GET_CUSTOM_GROUP_LIST_FAILURE,
)<GetCustomGroupListRequestInterface, CustomGroupPaginatedResponse, { error: string }>();
